import DataTableV2Paginated from '@/agilis/components/DataTableV2Paginated/DataTableV2Paginated'
import DataTableTitle from '@/agilis/components/DataTableV2/DataTableV2Title/DataTableV2Title.vue'
import SearchPaginatedMixin from '@/agilis/components/DataTableV2/common/searchPaginatedMixin'
import renderMixinMobile from '../ListCardMobileMixins/renderMixinMobile'
import searchPaginatedMobileMixin from '@/agilis/mobile/ListCardMobileMixins/searchPaginatedMobileMixin'
import { mapGetters } from 'vuex'

export default {
  name: 'DataTableV2PaginatedMobile',
  mixins: [DataTableV2Paginated, SearchPaginatedMixin, renderMixinMobile, searchPaginatedMobileMixin],
  components: {
    DataTableTitle
  },
  created () {
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  },
  mounted () {
    this.$store.commit('mobileDataTableStore/setAvailableViews', this.filtersInProfile.filter(f => f.route === this.filterRoute))
  },
  computed: {
    ...mapGetters({
      filtersInProfile: 'userDataStore/filters',
      searchTxtCommand: 'mobileDataTableStore/getSearchTxt',
      listViewsFilter: 'mobileDataTableStore/getAvaibleViews',
      viewSelected: 'mobileDataTableStore/getSavedSelectedView'
    })
  },
  watch: {
    viewSelected (newValue) {
      this.applyFilter(newValue)
    },
    searchTxtCommand (newValue) {
      this.handleSearchTxtInput(newValue)
    }
  }
}
